import { render, staticRenderFns } from "./SignatureModal.vue?vue&type=template&id=2bbaf06c&"
import script from "./SignatureModal.vue?vue&type=script&lang=ts&"
export * from "./SignatureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports